module.exports = __webpack_public_path__ + "img/bt.910c0587.jpg";